document.addEventListener("DOMContentLoaded", (event) => {
    //Cursor
    let mouseX = window.innerWidth / 2; // Default to center of the screen
    let mouseY = window.innerHeight / 2;
  
    window.addEventListener("mousemove", e => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      xTo(mouseX);
      yTo(mouseY);
    });
  
    gsap.set(".cursor", {
      x: mouseX,
      y: mouseY,
      xPercent: -50,
      yPercent: -50
    });
  
    let xTo = gsap.quickTo(".cursor", "x", {duration: 0.2, ease: "power3"});
    let yTo = gsap.quickTo(".cursor", "y", {duration: 0.2, ease: "power3"});
  
    window.addEventListener("load", () => {
      setTimeout(() => {
        document.querySelector(".cursor").classList.add("ready");
      }, 60); // Adjust the delay as needed
    });
    
   });
  
  
   // Toggle the active class on the burger menu when the button is clicked
   document.querySelector('[data-bs-toggle="collapse"]').addEventListener('click', function() {
    document.getElementById('burger-menu').classList.toggle('active');
  });

